<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col>
          <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="Buscar">
              <el-input
                v-model="form.search"
                placeholder="Buscar por nombre de usuario"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item label-width="0">
              <el-table
                :data="filterData"
                style="width: 100%"
                height="250"
                v-loading="loading"
              >
                <el-table-column width="60" fixed align="center">
                  <template slot="header" slot-scope="scope">
                    <i class="el-icon-setting" :key="scope.$index"></i>
                  </template>
                  <template slot-scope="scope">
                    <el-button
                      icon="el-icon-plus"
                      circle
                      size="mini"
                      type="primary"
                      :key="scope.$index"
                      @click="addUser(scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="FullName" label="Nombre" min-width="200">
                </el-table-column>
                <el-table-column
                  prop="UserName"
                  label="Usuario"
                  min-width="150"
                />
              </el-table>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: "ShareCalendar",
  props: ["users"],
  data() {
    return {
      keySearch: "FullName",
      loading: false,
      form: {
        search: null
      },
      drawer: false,
      columns: [
        {
          prop: "FullName",
          name: "Nombre"
        }
      ]
    };
  },
  computed: {
    filterData() {
      var filterable = [];
      let getTypeParams = typeof this.form.search;
      if (getTypeParams != "object") {
        if (this.form.search.trim().length == 0) {
          // input filter with blanck value
          filterable = this.users;
        } else {
          if (this.form.search !== null) {
            filterable = this.users.filter((data) => {
              const value = data[this.keySearch];
              const valueType = typeof value;

              if (valueType === "number") {
                return value.toString() === this.form.search;
              }

              return (
                !this.form.search ||
                data[this.keySearch]
                  .toLowerCase()
                  .includes(this.form.search.toLowerCase()) ||
                data["UserName"]
                  .toLowerCase()
                  .includes(this.form.search.toLowerCase())
              );
            });
          } else {
            filterable = this.users;
          }
        }
      } else {
        filterable = this.users;
      }

      return filterable;
    }
  },
  methods: {
    addUser(user) {
      this.$emit("add-user", user);
    }
  }
};
</script>

<style></style>
